import type { SelectUserPlan } from '~/graphql/generated/schema-types';
import { AddonEnumLocal } from '~/data/addons';
import { UserPlan } from '~/graphql/generated/schema-types';

export type PlanInfoLocal = {
  price: number
  priceAnnually?: number
  requestsPerMinute: number
  maxApiRequestsCount: number
} & Record<AddonEnumLocal, number>

export const PLANS: Record<
  SelectUserPlan,
  PlanInfoLocal
> = {
  [UserPlan.Standard]: {
    price: 49990,
    priceAnnually: 49990 * 11,
    requestsPerMinute: 30,
    maxApiRequestsCount: 10000,
    [AddonEnumLocal.MIN_PRICES]: 60 * 1000,
    [AddonEnumLocal.MAX_ORDERS]: 60 * 1000,
    [AddonEnumLocal.PRICE_RECOMMENDATIONS]: 60 * 60 * 1000 * 3,
    [AddonEnumLocal.STEAM_ANALYTICS]: 60 * 60 * 1000 * 3,
    [AddonEnumLocal.MARKET_ORDER_ANALYTICS]: 60 * 60 * 1000 * 3, // 3 hours,
    [AddonEnumLocal.ADDITIONAL_API_REQUESTS]: 0,
  },
  [UserPlan.Pro]: {
    price: 99990,
    priceAnnually: 99990 * 11,
    requestsPerMinute: 60,
    maxApiRequestsCount: 50000,
    [AddonEnumLocal.MIN_PRICES]: 60 * 1000,
    [AddonEnumLocal.MAX_ORDERS]: 60 * 1000,
    [AddonEnumLocal.PRICE_RECOMMENDATIONS]: 60 * 60 * 1000,
    [AddonEnumLocal.STEAM_ANALYTICS]: 60 * 60 * 1000,
    [AddonEnumLocal.MARKET_ORDER_ANALYTICS]: 60 * 60 * 1000, // 3 hours
    [AddonEnumLocal.ADDITIONAL_API_REQUESTS]: 0,
  },
};

// plans
// Стандарт - 49.99$
// 30 req/min
// aggregatedMinPrices - частота обновления 1 мин
// aggregatedMaxOrders - частота обновления 1 мин
// getPriceRecommendation - частота обновления 3 часа
// getSteamAnalytics - частота обновления 3 часа
// getMarketOrderAnalytics - частота обновления 3 часа
//
// Про - 99.99$
// 60 req/min
// aggregatedMinPrices - частота обновления 1 мин
// aggregatedMaxOrders - частота обновления 1 мин
// getPriceRecommendation - частота обновления 1 час
// getSteamAnalytics - частота обновления 1 час
// getMarketOrderAnalytics - частота обновления 1 час
